import { useState } from 'react';

import { TextField } from "@material-ui/core";

import CountryRegionData from 'country-region-data/data.json';
import { APPLICATION_PHONE_PATTERN, formatApplicationPhone } from '../../../phoneNumbers';


export default function ApplicantFields({ prefix, setFirstName, setLastName }) {
  const [country, setCountry] = useState('United States');
  const autoComplete = (field) => `section-${prefix.replace(/-$/, '')} ${field}`;
  const selectedCountry = CountryRegionData.find((c) => c.countryName === country);
  const regions = selectedCountry ? selectedCountry.regions : [];

  return (
    <React.Fragment>
      <div className="quoteform__grid">
        <div className="quoteform__input">
          <TextField
            fullWidth
            required
            label="First Name"
            variant="outlined"
            onChange={({ target: { value } }) => setFirstName(value) }
            name={prefix + 'first-name'}
            id={prefix + 'first-name'}
            autoComplete={autoComplete('given-name')}
          />
        </div>
        <div className="quoteform__input">
          <TextField
            fullWidth
            required
            label="Last Name"
            variant="outlined"
            onChange={({ target: { value } }) => setLastName(value) }
            name={prefix + 'last-name'}
            id={prefix + 'last-name'}
            autoComplete={autoComplete('family-name')}
          />
        </div>
      </div>
      <div className="quoteform__input">
        <TextField
          fullWidth
          required
          label="Email Address"
          variant="outlined"
          name={prefix + 'email'}
          id={prefix + 'email'}
          type="email"
          autoComplete={autoComplete('email')}
        />
      </div>
      <div className="quoteform__input">
        <TextField
          fullWidth
          required
          type="tel"
          inputProps={{
            pattern: APPLICATION_PHONE_PATTERN,
          }}
          label="Phone Number"
          variant="outlined"
          name={prefix + 'phone'}
          id={prefix + 'phone'}
          autoComplete={autoComplete('tel')}
          onBlur={({ target }) => {
            target.value = formatApplicationPhone(target.value, selectedCountry ? selectedCountry.countryShortCode : null);
          }}
        />
      </div>
      <div className="quoteform__grid quoteform__grid--canWrap">
        <div className="quoteform__input quoteform__input--is-3-3-sm">
          <TextField
            fullWidth
            required
            label="Street Address"
            variant="outlined"
            name={prefix + 'streetaddress'}
            id={prefix + 'streetaddress'}
            autoComplete={autoComplete('address-line1')}
          />
        </div>
        <div className="quoteform__input quoteform__input--is-3-3-sm">
          <TextField
            fullWidth
            label="Apt / Suite"
            variant="outlined"
            name={prefix + 'other'}
            id={prefix + 'other'}
            autoComplete={autoComplete('address-line2')}
          />
        </div>
      </div>
      <div className="quoteform__input">
        <TextField
          select
          fullWidth
          label="Country"
          name={prefix + 'country'}
          id={prefix + 'country'}
          autoComplete={autoComplete('country-name')}
          SelectProps={{ native: true }}
          InputLabelProps={{ shrink: true }}
          onChange={({ target: { value } }) => setCountry(value)}
          value={country}
          variant="outlined"
          required
        >
          {CountryRegionData.map((country) => {
            return (
              <option key={country.countryShortCode} value={country.countryName}>{country.countryName}</option>
            );
          })}
        </TextField>
      </div>
      <div className="quoteform__grid quoteform__grid--canWrap">
        <div className="quoteform__input quoteform__input--is-3-3-sm">
          <TextField
            fullWidth
            required
            label="City"
            variant="outlined"
            name={prefix + 'city'}
            id={prefix + 'city'}
            autoComplete={autoComplete('address-level2')}
          />
        </div>
        <div className="quoteform__input quoteform__input--is-3-3-sm quoteform__input--isLeft">
          <TextField
            key={country}
            select
            fullWidth
            label="State / Region"
            name={prefix + 'state'}
            id={prefix + 'state'}
            defaultValue=""
            variant="outlined"
            required
            autoComplete={autoComplete('address-level1')}
            SelectProps={{ native: true }}
            InputLabelProps={{ shrink: true }}
          >
            <option value="" />
            {regions.map((region) => (
                <option key={region.name + '_' + region.shortcode} value={region.name}>{region.name}</option>
            ))}
          </TextField>
        </div>
        <div className="quoteform__input quoteform__input--is-3-3-sm quoteform__input--isRight">
          <TextField
            fullWidth
            required
            label="Postal Code"
            variant="outlined"
            name={prefix + 'postalcode'}
            id={prefix + 'postalcode'}
            autoComplete={autoComplete('postal-code')}
            inputProps={{ maxLength: 5 }}
          />
        </div>
      </div>
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// blocks/quote-calculator/app/components/LoanApplication/components/ApplicantFields.js